import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["checked", "disabled"]

import SettingsOption from "@/components/utils/SettingsOption.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleOption',
  props: {
    modelValue: { type: Boolean },
    label: {},
    tooltip: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsOption, {
    label: _ctx.label,
    tooltip: _ctx.tooltip
  }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        type: "checkbox",
        class: "toggle",
        checked: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target?.checked))),
        disabled: _ctx.disabled
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["label", "tooltip"]))
}
}

})